import { render, staticRenderFns } from "./ServiceInformation.vue?vue&type=template&id=25471ad7"
import script from "./ServiceInformation.vue?vue&type=script&lang=js"
export * from "./ServiceInformation.vue?vue&type=script&lang=js"
import style0 from "./ServiceInformation.vue?vue&type=style&index=0&id=25471ad7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports